import React from 'react';
import { useFormikContext } from 'formik';

import Question from './Question';

const QuestionContainer = ({
  questionIndex,
  ...restProps
}: { questionIndex: any } & Record<string, any>) => {
  const { setFieldValue } = useFormikContext<any>();

  const handleAnswersTypeClick = (option: any) => {
    setFieldValue(`questions[${questionIndex}].answersType`, option.value);
  };

  return (
    <Question
      {...restProps}
      questionIndex={questionIndex}
      onAnswersTypeClick={handleAnswersTypeClick}
    />
  );
};

export default React.memo(QuestionContainer) as any;
